import React, {useEffect, useState} from 'react';
import useToggle from '../../Hooks/useToggle';
import FooterHomeOne from '../HomeOne/FooterHomeOne';
import {CloseCircleOutlined, LikeOutlined, SmileOutlined} from '@ant-design/icons';
import {  Carousel, Modal } from 'antd';

import HeaderHomeSeven from '../HomeSeven/HeaderHomeSeven';

import Drawer from '../Drawer';
import BackToTop from '../BackToTop';

import { ConsumeApi } from '../../servicesWorker/ConsumeApi';
import { notification } from 'antd';

function VotesScreen({className}) {
    const [drawer, drawerAction] = useToggle(false);
    const [indexCategorie, changeIndexCategorie] = useState(0);
    const [itemVoted, choiceItemVoted] = useState([]);
    const [infoVoted, setInfoVoted] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [viewVoted, setViewVoted] = useState(false);
    const [votedByFacebookComponent, changeVotedByFacebookComponent] = useState(true);
    const consumeApi = new ConsumeApi();

      const displayPub = () => {
        const publicité = localStorage.getItem("publicité") ?? "";
        if(publicité === "") {
          showModal();
          localStorage.setItem("publicité", new Date().getTime().toString());
        } else {
          const lastDate = parseInt(publicité, 10)/ 1000;
          if(new Date().getTime()/1000 - lastDate > 172800) {
          showModal();
          localStorage.setItem("publicité", new Date().getTime().toString());
          }
        }
      }
      const showModal = () => {
        setIsModalOpen(true);
      };
    
      const handleOk = () => {
        setIsModalOpen(false);
      };
    
      const handleCancel = () => {
        setIsModalOpen(false);
      };

    // Hooks Effet
    useEffect(() => {
        const userID = localStorage.getItem("identShouz") ?? "";
        if(userID === "") {
            createUser();
        }
        loadData();
    }, []);

    const loadData = async () => {
        const data = await consumeApi.getAllVote();
        console.log(data);
    }

    const createUser = async () => {
        const create = await consumeApi.createBlanckUser();
        console.log(create);
    }

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderHomeSeven action={drawerAction.toggle} />
            <section className={`appie-project-3-area ${className}`}>
            <div className="appie-project-3-box d-block d-md-flex justify-content-between align-items-center wow animated fadeInUp"
                  data-wow-duration="2000ms"
                  data-wow-delay="400ms" onDoubleClick={(event)=> {
                    event.preventDefault();
                    //setViewVoted(!viewVoted);
                  }}>
                <h4 className="title">
                    Les vôtes du moments
                </h4>
                                
            </div>
            </section>
            <section className="blogpage-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            <div className="row">
                                
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <div className="blog-sidebar">

                                <aside className="widget widget-categories">
                                    <h3 className="widget-title">Pub</h3>
                                    <ul>
                                        
                                        
                                    </ul>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default VotesScreen;